module.exports = __webpack_public_path__ + "img/img10.131d5381.svg";